import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ChannelLayoutEntity } from '../../domain/entities/ChannelLayoutEntity'

export class ChannelLayoutModel extends ChannelLayoutEntity {
  constructor(dataDto: ChannelLayoutEntity) {
    super()
    mapEntityProperties<ChannelLayoutModel>(this, dataDto, {
      map: {
        channelId: dataDto.id
      }
    })
  }
}
